var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"drawInfoOverlay"},[_c('p',[_c('fa-icon',{attrs:{"icon":"route","transform":"shrink-3"}}),_vm._v(" "+_vm._s(Number(_vm.drawInfo.distance).toLocaleString())+" m")],1),_vm._v(" "),_c('p',[_c('fa-icon',{attrs:{"icon":"compass","transform":"shrink-3"}}),_vm._v(" "+_vm._s(_vm.drawInfo.bearing)+"°")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }